import { useRouter } from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import BlogLogo from './logo'
import { cn } from '../../../../../shadcn/utils'
import { getCollectionPathname } from '../../../../../utils/house-explorer-url-params.helper'
import NextImage from '../../../../atoms/containers/Image/next-image'
import Button from '../../../../atoms/fields/Button/Button'
import { BUTTON_COLOR } from '../../../../atoms/fields/Button/button.enum'

export function Banner() {
  const router = useRouter()
  const collectionPath = getCollectionPathname({})

  return (
    <article className={cn(s.banner, 'not-prose')}>
      <div className={s.content}>
        <h3 className={s.title}>
          <FormattedMessage
            id='ui.blog.post.banner.title'
            defaultMessage='Organisez votre séminaire grâce à Naboo !'
          />
        </h3>
        <p className={s.subtitle}>
          <FormattedMessage
            id='ui.blog.post.banner.subtitle'
            defaultMessage='Découvrez notre collection de plus de 10000 lieux idéaux pour vos séminaire, journée d’études et événement d’entreprise.'
          />
        </p>

        {/* TODO: Use `Button` style with a simple <a> when possible */}
        <Button
          color={BUTTON_COLOR.PRIMARY}
          className={s.bannerButton}
          onClick={() => router.push(collectionPath)}
        >
          <FormattedMessage
            id='ui.blog.post.banner.cta'
            defaultMessage='Découvrir la collection'
          />
        </Button>
      </div>

      <div className={s.imagesWrapper}>
        <div className={s.logo}>
          <BlogLogo />
        </div>
        <div className={s.person}>
          <NextImage src='/images/blog/person.webp' alt='banner_logo' />
        </div>
      </div>
    </article>
  )
}
